export interface MediaFile {
  name: string;
  fileName: string;
}
